export const parameterizeString = (value: string): string =>
  value.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, '').replace(/\s/g, '-')
